'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../components/navBar';
import SideMenu from '../components/sideMenu';
import menuAction from '../actions/menuAction';
import userSetAction from '../actions/userSetAction';
import userSetStore from '../stores/userSetStore';
import employeeAction from '../actions/employeeAction';
import employeeStore from '../stores/employeeStore';
import UserSetHeader from './userSetComponents/userSetHeader';
import UserSetBody from './userSetComponents/userSetBody';
import UserSetForm from './userSetComponents/userSetForm';
import UserEditForm from './userSetComponents/userEditForm';
import Loading from '../components/loading';

class UserSetting extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.state = {
            warningMsg: userSetStore.getState().warningMsg,
            usMode: userSetStore.getState().usMode,
            processing: userSetStore.getState().processing,
            search: userSetStore.getState().search,
            updating: userSetStore.getState().updating,
            staffId: userSetStore.getState().staffId,
            staffs: employeeStore.getState().staffs,
            processingFilter: employeeStore.getState().processing,
            iniLoadStaff: employeeStore.getState().iniLoadStaff,
        };
    }
    
    componentDidMount() {
        menuAction.pageNumber(10);
        userSetStore.listen(this.onChange);
        employeeStore.listen(this.onFilterChange);
        if (!this.state.processingFilter && !this.state.iniLoadStaff) {
            employeeAction.processing(true);
            employeeAction.getEmployee();
        }

    }
    componentWillUnmount() {
        userSetStore.unlisten(this.onChange);
        employeeStore.unlisten(this.onFilterChange);
    }
    onFilterChange(state){
        this.setState({
            staffs: state.staffs,
            processingFilter: state.processing,
            iniLoadStaff: state.iniLoadStaff,
        });
    }
    onChange(state) {
        this.setState({
            warningMsg: state.warningMsg,
            usMode: state.usMode,
            processing: state.processing,
            search: state.search,
            updating: state.updating,
            staffId: state.staffId,
        });
    }

    render() {
        let staffs;
        if (this.state.staffs.length > 0) {
            staffs = this.state.staffs.filter((staff) => {
                return (
                    staff.userName.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1 ||
                    staff.staffId.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1
                );
            });
        }

        let contentDisplay = '';
        if(this.state.usMode == 0){
            contentDisplay = <UserSetForm staffs={this.state.staffs} usMode={this.state.usMode} />;
        }else{
            if(!this.state.updating){
                contentDisplay = <UserSetBody staffs={staffs} usMode={this.state.usMode}/>;
            }else{
                contentDisplay = <UserEditForm staffs={this.state.staffs} usMode={this.state.usMode} staffId={this.state.staffId} />;
            }
            
        }
        
        return (
            <div className="container-fluid content">
                <div className="row">
                    <NavBar {...this.props} />
                    <SideMenu {...this.props} />
                    <div className=" col-md-10  col-sm-8">
                        <UserSetHeader staffs={this.state.staffs} processing={this.state.processing} usMode={this.state.usMode} updating={this.state.updating} />
                        {contentDisplay}
                    </div>
                </div>
                <Loading processing={this.state.processing || this.state.processingFilter}/>
            </div>
        );
    }
}
export default UserSetting;


// WEBPACK FOOTER //
// ./app/setComponents/userSetting.js